import { create } from 'zustand'

export type CameraViewPreset = 'auto' | 'periodic_table' | 'emergency_shower' | 'safety_first' | 'side_desk' | 'wall_clock' | 'first_person';

interface UiState {
    showTutorial: boolean;
    showQuiz: boolean;
    showMolecular: boolean;
    showResults: boolean;
    showAssistant: boolean;
    assistantEnabled: boolean;
    sidebarTab: 'controls' | 'data' | 'chart' | 'exercises';
    cameraResetKey: number;
    activeCameraView: CameraViewPreset;
    arEnabled: boolean;           // AR / gesture system on/off
    arPhTooltip: boolean;         // pH meter 3D tooltip visible
    showARTutorial: boolean;      // AR gesture tutorial overlay
    toggleTutorial: () => void;
    setShowTutorial: (show: boolean) => void;
    setShowQuiz: (show: boolean) => void;
    toggleMolecular: () => void;
    toggleAssistant: () => void;
    toggleResults: () => void;
    setShowResults: (show: boolean) => void;
    setSidebarTab: (tab: 'controls' | 'data' | 'chart' | 'exercises') => void;
    resetCamera: () => void;
    setActiveCameraView: (view: CameraViewPreset) => void;
    setArEnabled: (enabled: boolean) => void;
    setArPhTooltip: (show: boolean) => void;
    setShowARTutorial: (show: boolean) => void;
    setShowAssistant: (show: boolean) => void;
    setAssistantEnabled: (enabled: boolean) => void;
    resetUi: () => void;
}

export const useUiStore = create<UiState>((set) => ({
    showTutorial: false,
    showQuiz: false,
    showMolecular: false,
    showAssistant: true,
    assistantEnabled: true,
    showResults: false,
    sidebarTab: 'controls',
    cameraResetKey: 0,
    activeCameraView: 'auto',
    arEnabled: false,
    arPhTooltip: false,
    showARTutorial: false,
    resetUi: () => set({
        showTutorial: false,
        showQuiz: false,
        showMolecular: false,
        showResults: false,
        sidebarTab: 'controls',
        activeCameraView: 'auto',
        arEnabled: false,
        arPhTooltip: false,
        showARTutorial: false
    }),
    toggleTutorial: () => set((state) => ({ showTutorial: !state.showTutorial })),
    setShowTutorial: (show) => set({ showTutorial: show }),
    setShowQuiz: (show) => set({ showQuiz: show }),
    toggleMolecular: () => set((state) => ({ showMolecular: !state.showMolecular })),
    setShowAssistant: (show: boolean) => set({ showAssistant: show }),
    setAssistantEnabled: (enabled: boolean) => set({ assistantEnabled: enabled }),
    toggleAssistant: () => set((state) => ({ showAssistant: !state.showAssistant })),
    toggleResults: () => set((state) => ({ showResults: !state.showResults })),
    setShowResults: (show) => set({ showResults: show }),
    setSidebarTab: (tab) => set({ sidebarTab: tab }),
    resetCamera: () => set((state) => ({ cameraResetKey: state.cameraResetKey + 1, activeCameraView: 'auto' })),
    setActiveCameraView: (view) => set({ activeCameraView: view }),
    setArEnabled: (enabled) => set({ arEnabled: enabled }),
    setArPhTooltip: (show) => set({ arPhTooltip: show }),
    setShowARTutorial: (show) => set({ showARTutorial: show }),
}))
